import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import Icon from '@dustin-web/microsite-components/src/icon'
import ReviewStars from '@dustin-web/product-components/src/review-stars'
import { Language, ReviewType } from '@productsite-beta/src/graphql/generated/graphql-types'

type UserProps = {
  userReviews:
    | ({
        author?: string | null
        type: ReviewType
        content?: string | null
        created: any
        domain?: string | null
        isVerified: boolean
        isTranslated: boolean
        score: number
        language: Language
      } | null)[]
    | null
    | undefined
}

const UserReviews = ({ userReviews }: UserProps) => {
  const { translate } = useI18n()

  const reviews = userReviews?.map((review, i, arr) => {
    const lastItem = i === arr?.length - 1 ? true : false
    if (review) {
      return (
        <article
          key={`${review.author}` + i}
          className={lastItem ? 'review-card--last' : 'review-card'}>
          <div className="review-card__userFlexContainer">
            <header className="review-card__userReviewInfoContainer">
              <div className="review-card__score">
                <ReviewStars reviewScore={review.score} aria-label="Stars showing review rating" />
              </div>
              <h3 className="review-card__alias h5">{review.author}</h3>
              {review.isVerified && (
                <small className="review-card__verifiedContainer">
                  <Icon
                    className="review-card__verifiedIcon u-color-dark-green"
                    name="security-2"
                    aria-label="Verfied customer badge"
                  />
                  <span className="review-card__verifiedText u-color-dark-green">
                    {translate('Product_Review_Verified')}
                  </span>
                </small>
              )}
              <small className="review-card__sourceAndDate c-pipe-separator c-pipe-separator--compact">
                <time dateTime={review.created?.substring(0, 10)} aria-label="Review date">
                  {review.created?.substring(0, 10)}
                </time>
                <span>{review.domain}</span>
              </small>
            </header>
            <section className="review-card__userReviewContentContainer">
              <div className="review-card__userContent">
                <p>{review.content}</p>
              </div>
              {review.isTranslated && (
                <span
                  className="review-card__translatedByGoogle"
                  aria-label="This review was translated by Google">
                  {translate('Product_Review_TranslatedByGoogle')}
                </span>
              )}
            </section>
          </div>
        </article>
      )
    }
  })

  return <>{reviews}</>
}

export default UserReviews
